export default __webpack_public_path__ + "static/app-features-4--mobile-7c08825f17a10b3bc2852b88b36a3d37.webp";